import { defineComponent as _defineComponent } from 'vue'
import { onMounted, ref } from 'vue'

interface TargetType {
  e: MouseEvent
  el: HTMLImageElement
  startX: number
  startY: number
  offsetX: number
  offsetY: number
  scaleX: number
  scaleY: number
  width: number
  height: number
}


export default /*#__PURE__*/_defineComponent({
  __name: 'g-drag-image',
  props: {
    src: null,
    data: null,
    uniqueId: null,
    isDrag: { type: Boolean, default: true },
    setRectSize: { type: Function, default: (width: number, height: number) => {
      return {
        width,
        height,
      }
    } }
  },
  emits: [
  'onClick',
  'onMouseMove',
  'onMouseUp',
  'onTargetPositionChange',
],
  setup(__props: any, { expose, emit: emits }) {

const props = __props as { src: string, data: any, uniqueId?: string, isDrag: boolean, setRectSize: (
      width: number,
      height: number
    ) => { width: number; height: number } }




const target = ref<TargetType>()
// 收集点击生成的元素，在鼠标放下以及页面销毁时清除这些元素，避免意外的操作导致元素没有被删除
const collectEl = ref<Element[]>([])

async function genImageOrPositionByEvent(
  e: MouseEvent,
  src: string,
  setRectSize?: (...args: any) => { width: number; height: number }
) {
  const image = new Image()
  image.src = src
  const result = await new Promise<{ width: number; height: number }>(
    (resolve) => {
      image.onload = function (this: any) {
        const { width, height } = setRectSize
          ? setRectSize(this.width, this.height)
          : { width: this.width, height: this.height }
        resolve({ width, height })
      }
    }
  )
  const offset = getMousePositionByImage(e)
  const { clientX, clientY } = e
  // 起始位置
  const startX = clientX - offset.scaleX * result.width
  const startY = clientY - offset.scaleY * result.height
  // 鼠标在图片上的偏移量
  const offsetX = clientX - startX
  const offsetY = clientY - startY
  const data: TargetType = {
    e,
    el: image,
    startX,
    startY,
    offsetX,
    offsetY,
    ...result,
    ...offset,
  }
  emits('onTargetPositionChange', data, 'gen')
  return data
}

/** 重置图片的URL */
async function resetImageUrl(src: string) {
  const { e, el } = target.value ?? {}
  if (!e || !el) return
  const data = await genImageOrPositionByEvent(e, src, props.setRectSize)
  el.src = src
  el.width = data.width
  el.height = data.height
  target.value = { ...data, el }
  setImagePosition(e, target.value!)
  emits('onTargetPositionChange', target.value, 'reset')
}

/** 当点击图片时 */
async function handleImageDown(e: MouseEvent) {
  e.preventDefault()
  const data = await genImageOrPositionByEvent(e, props.src, props.setRectSize)
  const { el: image } = data
  // 收集图片元素
  collectEl.value.push(image)
  target.value = data
  // 开启内部拖拽时才生成元素进行拖拽
  if (props.isDrag) {
    // 延迟渲染，可能存在其他替换图片操作避免闪烁
    setTimeout(() => {
      image.style.cursor = 'grabbing'
      image.setAttribute('data-unique-id', String(props.uniqueId))
      image.style.opacity = '0.7'
      document.body.appendChild(image)
      setImagePosition(e, target.value as any)
    })
  }
  // 添加两个事件
  window.addEventListener('mousemove', globalMouseMove)
  window.addEventListener('mouseup', clearEvent)
  // 抛出结果
  emits('onClick', data, e, props.data, {
    resetImageUrl,
  })
}
/** 当在图片抬起时 */
function handleImageUp(e: MouseEvent) {
  clearEvent(e)
}

/** 监听鼠标移动事件 */
function globalMouseMove(e: MouseEvent) {
  e.preventDefault()
  if (!target.value) return
  // 移动时始终更新目标的event对象
  target.value.e = e
  setImagePosition(e, target.value)
  emits('onMouseMove', target.value, e, props.data)
}

/** 移除全局事件 */
function clearEvent(e: MouseEvent) {
  clearCollectEl()
  emits('onMouseUp', target.value, e, props.data)
  // 清除所有的引用
  target.value = undefined

  window.removeEventListener('mousemove', globalMouseMove)
  window.removeEventListener('mouseup', clearEvent)
}

/** 设置一个图片的位置 */
function setImagePosition(e: MouseEvent, data: TargetType) {
  const { el, scaleX, scaleY, width, height } = data
  const x = e.clientX - scaleX * width
  const y = e.clientY - scaleY * height
  el.style.position = 'fixed'
  el.style.left = `${x}px`
  el.style.top = `${y}px`
  el.style.zIndex = '9999999'
}

/** 得到鼠标在目标图片上的相对比例 */
function getMousePositionByImage(e: MouseEvent) {
  const { offsetX, offsetY } = e
  const { width, height } = (
    e.target as HTMLImageElement
  ).getBoundingClientRect()
  return {
    scaleX: offsetX / width,
    scaleY: offsetY / height,
  }
}

/** 清除收集的el */
function clearCollectEl() {
  collectEl.value.forEach((el) => {
    document.body.removeChild(el)
  })
  collectEl.value = []
}

onMounted(() => {
  clearCollectEl()
})

expose({
  resetImageUrl,
})

return { __sfc: true,props, emits, target, collectEl, genImageOrPositionByEvent, resetImageUrl, handleImageDown, handleImageUp, globalMouseMove, clearEvent, setImagePosition, getMousePositionByImage, clearCollectEl }
}

})